import React from 'react'
import { SignIn as ClerkSignIn } from '@clerk/clerk-react'
import { clerkAppearance } from '../../utils/clerkAppearance'
import './Auth.scss'
import './BackgroundAnimation.scss'

export function SignIn() {
    return (
        <div className="App sign-in">
            <div id="background-animation">
                <img className="callouts" src="/images/login/callouts.png" alt="" />
                {[...Array(16)].map((_, i) => {
                    if (i === 3) return null
                    return (
                        <img
                            key={i}
                            className={`element e${(i % 5) + 1} o${(i % 5) + 1}`}
                            src={`/images/login/${i + 1}.png`}
                            alt=""
                        />
                    )
                })}
                <img className="logo" src="/images/login/BO-Logo5.png" alt="" />
            </div>
            <div id="background-animation-screen" />
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1,
                    padding: 16,
                }}
            >
                <ClerkSignIn
                    routing="hash"
                    signUpUrl="/sign-up"
                    forceRedirectUrl="/"
                    fallbackRedirectUrl="/"
                    appearance={clerkAppearance}
                />
            </div>
        </div>
    )
}
